export default __webpack_public_path__ + "static/media/banner2.73b92cc4.jpeg";